<div class="page">
  <div class="content">
    @if (isReady) {
      <div class="card">
        <div class="icon-container">
          <i class="fa-solid fa-xmark feedback-icon"></i>
        </div>
        <div class="text-content">
          <h2 class="heading">{{ 'web.paymentCancelledHeading' | translate }}</h2>
          <p class="body">{{ 'web.paymentCancelledBody' | translate }}</p>
        </div>
      </div>
    }
  </div>

  @if (isReady) {
    <div class="footer">
      <div class="footer-container">
        <button class="btn-outlined" (click)="onTryAgain()">
          {{ 'web.tryAgain' | translate }}
        </button>
        <button class="btn-text" (click)="onGoBack()">
          <i class="fa-solid fa-arrow-left"></i>
          {{ 'web.goBack' | translate }}
        </button>
      </div>
    </div>
  }
</div>
